// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"698":"731661b60cfcd628","801":"f76c13f0017a1ea8","825":"743b81d3c40cd837"}[chunkId] + ".js";
};